var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as S3 from 'aws-sdk/clients/s3';
import { SelfService } from '../self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import * as i0 from "@angular/core";
import * as i1 from "../self-services.service.ts";
import * as i2 from "ng4-loading-spinner";
import * as i3 from "../../environment/services/environment.configuration";
var UploadService = /** @class */ (function () {
    function UploadService(diService, spinnerService, environment1) {
        this.diService = diService;
        this.spinnerService = spinnerService;
        this.environment1 = environment1;
        this.bucketEnv = '';
    }
    UploadService.prototype.getPresignedUrl = function (file, awsDetails, uploadDataForFiles, flag) {
        return __awaiter(this, void 0, void 0, function () {
            var accesKey, secretKey, region, bucket, params, preSignedGetUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accesKey = awsDetails.accessId;
                        secretKey = awsDetails.secretKey;
                        region = awsDetails.region;
                        bucket = new S3({
                            accessKeyId: sessionStorage.getItem('AccessKeyId'),
                            secretAccessKey: sessionStorage.getItem('SecretKeyId'),
                            sessionToken: sessionStorage.getItem('SessionToken'),
                            region: region,
                        });
                        console.log('bucket env :' + this.environment1.envName);
                        if (this.environment1.envName == "qa") {
                            this.bucketEnv = 'qa-bpg-toyota-com-web-content';
                        }
                        else if (this.environment1.envName == "dev") {
                            this.bucketEnv = 'dev.bpg.toyota.com-web-content';
                        }
                        else if (this.environment1.envName == "prod") {
                            this.bucketEnv = 'bpg-toyota-com-web-content';
                        }
                        else {
                            this.bucketEnv = 'dev.bpg.toyota.com-web-content';
                        }
                        if (flag == 'resource') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/di_documents/di_resources/' + uploadDataForFiles, file.name, 'application/octet-stream', 120);
                        }
                        else if (flag == 'banner') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/di_documents/di_banner', uploadDataForFiles, 'application/octet-stream', 120);
                        }
                        else if (flag == 'news') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/di_documents/di_news', uploadDataForFiles, 'application/octet-stream', 120);
                        }
                        else if (flag == 'naacNews') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/naac_documents/naac_news', uploadDataForFiles, 'application/octet-stream', 120);
                        }
                        else if (flag == 'naacResource') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/naac_documents/naac_resources/' + uploadDataForFiles, file.name, 'application/octet-stream', 120);
                        }
                        else if (flag == 'chapterAnnouncements') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/chapter_announcements/' + uploadDataForFiles, file.name, 'application/octet-stream', 120);
                        }
                        else if (flag == 'create-expense') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/expense_documents/' + uploadDataForFiles, file.name, 'application/octet-stream', 120);
                        }
                        else if (flag == 'create-event') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/event_documents/' + uploadDataForFiles, file.name, 'application/octet-stream', 120);
                        }
                        else if (flag == 'chapter_notification') {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/chapter-notification/' + uploadDataForFiles, file.name, 'application/octet-stream', 120);
                        }
                        else {
                            params = this.buildUploadParams(this.bucketEnv + '/documents/chapter_gallery', uploadDataForFiles, 'application/octet-stream', 120);
                        }
                        preSignedGetUrl = bucket.getSignedUrl('putObject', params);
                        return [4 /*yield*/, this.diService.diput(preSignedGetUrl, file).then().catch(function (err) {
                                //console.log(err.stack); // This is the only way to see the stack
                                //alert(1);
                                localStorage.setItem('uploadError', 'Error');
                                throw err; // Where does this go?
                            }).catch(function (err) {
                                // alert(2);
                                //console.log(err.stack); // It goes here!
                            })];
                    case 1:
                        _a.sent();
                        this.spinnerService.hide();
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadService.prototype.buildUploadParams = function (bucket, key, contentType, expires) {
        return {
            Bucket: bucket,
            Key: key,
            ContentType: contentType,
            ACL: 'bucket-owner-full-control',
            Expires: expires
        };
    };
    UploadService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UploadService_Factory() { return new UploadService(i0.ɵɵinject(i1.SelfService), i0.ɵɵinject(i2.Ng4LoadingSpinnerService), i0.ɵɵinject(i3.EnvironmentConfiguration)); }, token: UploadService, providedIn: "root" });
    return UploadService;
}());
export { UploadService };
